module.exports = __webpack_public_path__ + "static/media/radiadores.7b07c02e.jpg";